<template lang="pug">
#wrapper
  .container
    .row
      .col-12
        h1 
        .carrier.card.shadow.mb-4
          .card-header.py-3
            h3.text-center.m-0.font-weight-bold.text-primary() Widget Tutorial 
          .card-body
            .row
              .col-12.text-center
                video(src="https://s3.wasabisys.com/rp-widget/img/widget-on-off.mp4" type="video/mp4" controls autoplay)
            ul
              li  We automatically install the returns widget directly on your storefront pages through Shopify's Script Tag API.
                img(src="@/assets/img/tutorials/widget_collapsed.png" title="Widget Collapsed" alt="Widget Collapsed")
                p This is how your widget will appear on your site
                img(src="@/assets/img/tutorials/widget_expanded.png" title="Widget Expanded" alt="Widget Expanded")
              li  The widget is hidden by default. 
              li  To show or hide the widget, toggle the switch on <b>Connections</b> -> <b>Sales Platforms</b> -> <b>Widget Settings</b>.
              li  You can also customize the widget on <b>Widget Settings</b>.
            //- p Go to your Shopify dashboard
            //- img(src="@/assets/img/tutorials/step1.png")
        //- .carrier.card.shadow.mb-4
        //-   .card-header.py-3
        //-     h3.text-center.m-0.font-weight-bold.text-primary() Step 2
        //-   .card-body
        //-     p Ｇo to admin
        //-     p Click on: Online store
        //-     img(src="@/assets/img/tutorials/step2.png")
   
        //- .carrier.card.shadow.mb-4
        //-   .card-header.py-3
        //-     h3.text-center.m-0.font-weight-bold.text-primary() Step 3
        //-   .card-body 
        //-     p At the <strong> themes </strong>
        //-     p Click actions and <strong> edit code </strong>
            
        //-     img(src="@/assets/img/tutorials/step3.png")
        //- .carrier.card.shadow.mb-4
        //-   .card-header.py-3
        //-     h3.text-center.m-0.font-weight-bold.text-primary() Step 4
        //-   .card-body   
        //-     p <strong> layout </strong> -> edit <strong> theme.liquid </strong>
        //-     img(src="@/assets/img/tutorials/step4.png")
           
        //- .carrier.card.shadow.mb-4
        //-   .card-header.py-3
        //-     h3.text-center.m-0.font-weight-bold.text-primary() Step 5
        //-   .card-body
        //-     p Add the script inside the head.  
        //-     img(src="@/assets/img/tutorials/step5.png")
</template>

<script>
export default {
  name: 'widgetInstall',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  img{
    width:100%;
    margin:30px 0;
  }
  video{
    width:70%;
    margin-bottom:30px;

  }
.container{margin-top:50px;}

</style>
